import { IApiResponse, IFixResponse, api, apiExternal } from '../index';

export async function getParqueServicoById(id: number | string): Promise<IFixResponse> {
  const res: IApiResponse = await api.get(`/reclamante/sgi/parqueservico/${id}`);

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const { data } = res;
  return { err: null, resp: data };
}

export interface IParqueServicoAnonimo {
  area_json?: any;
  cod_estado: number;
  cod_municipio: number;
  nom_estado: string;
  nom_municipio: string;
  nom_parque_servico: string;
}

export async function getParqueServicoByIdAnonimo(id: number | string): Promise<IFixResponse<IParqueServicoAnonimo>> {
  const res: IApiResponse = await api.get(`/external/parqueservico/id/${id}`);

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const { data } = res;
  return { err: null, resp: data };
}

export async function getMunicipioByParqueServico(codParque: number | string): Promise<IFixResponse> {
  const res: IApiResponse = await apiExternal.get(`/external/municipio/parqueservico/${codParque}`);

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const { data } = res;
  return { err: null, resp: data };
}

export async function verifyParqueExists(codParque: number | string): Promise<IFixResponse> {
  const res: IApiResponse = await apiExternal.get(`/external/parqueservico/verificar/${codParque}`);

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const { data } = res;
  return { err: null, resp: data };
}

export interface IHorarioAreaColetaParque {
  num_dia_semana: number;
  num_hora_inicial: string;
  num_hora_final: string;
}

export interface IAreaColetaParque {
  seq_area_coleta: number;
  nom_area_coleta: string;
  area_json: any[];
  area_coleta_horario?: IHorarioAreaColetaParque[];
}

export async function getAreasColetaParqueServico(codParque: number | string): Promise<IFixResponse> {
  const res: IApiResponse = await apiExternal.get(`/external/parqueservico/areas-coleta-parque/${codParque}`);

  if (res.failed) {
    if (res.message) {
      return { err: res.message, data: null };
    }
    return { err: res.err, data: null };
  }

  const { data } = res;
  return { err: null, resp: data };
}
